import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react'
import AreaService from '../../services/AreaService';
import { SlcServiceCookMappingEnum } from '../../enums/SlcServiceCookMappingEnum';
import CircularLoader from './CircularLoader';
import EventBus from '../../EventBus';
import { EventBusEventsEnum } from '../../enums/EventBusEventsEnum';
import { CustomSnackbarTypes } from './CustomSnackBar';
import { useRecordContext } from 'react-admin';


interface InputProps {
    open: boolean;
    cookId: number;
    callback: (data: any) => void;
}

let areaService = new AreaService();
function AddMultipleSlcsDialog(props: InputProps) {

    let[areaList,setAreaList] = useState<any[]>([]);
    const [mappingType, setMappingType] = useState<SlcServiceCookMappingEnum | undefined>(undefined);
    let [allServices, setAllServices] = useState<any>([]);
    const [selectedService, setSelectedService] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);

    let [selectedAreas, setSelectedAreas] = useState<any[]>([]);

    const record = useRecordContext();
    
    useEffect(() => {
        areaService.getAllServices().then((res) => {
            setAllServices(res);
        });
        areaService.fetchAllAreas(1000, 0, {cityId: record?.cookFullProfile?.cityId}, { "field": "name", "order": "ASC" }).then((res) => {
          setAreaList(res?.data);
        })
    },[record?.cookFullProfile?.cityId]);

    let handleSubmit = async () => {
        if (!mappingType || !selectedService || selectedAreas.length === 0) {
          EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
            message: "Missing required fields",
            type: CustomSnackbarTypes.ERROR,
          });
          return;
        }
      
        setLoading(true);
        let success = 0;
        let fails = 0;

        console.log(selectedAreas);
        for (const element of selectedAreas) {
          let payload = {
            referenceId: element?.value,
            referenceModelName: "AREA",
            serviceId: Number(selectedService),
            cookId: props?.cookId,
            mappingType: mappingType,
          };
      
          try {
            await areaService.addCooksToSlc(payload);
            success++;
          } catch (err) {
            console.log(err);
            fails++;
          }
        }
      
        setLoading(false);
      
        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
          message: `Added Successfully: ${success}, Failed: ${fails}`,
          type: CustomSnackbarTypes.SUCCESS,
        });
      
        setAllServices([]);
        setSelectedAreas([]);
        setAreaList([]);
        setSelectedService("");
        setMappingType(undefined);
        props.callback(true);
    };
  return (
    <Dialog open={props.open} scroll={"paper"} maxWidth="xl">
      <DialogTitle>Add Multiple Slc's</DialogTitle>
      <DialogContent>
        {
            loading ? <CircularLoader/> : 
        
      <>  
      <FormControl fullWidth>
        <InputLabel id="mapping-type-label">Select Mapping Type</InputLabel>
        <Select
            labelId="mapping-type-label"
            id="mapping-type"
            value={mappingType}
            label="Mapping Type"
            onChange={(event: SelectChangeEvent) => {
                setMappingType(event?.target?.value as SlcServiceCookMappingEnum)
            }}
        >
            {Object.values(SlcServiceCookMappingEnum).map((value) => (
                <MenuItem value={value}>{value}</MenuItem>
            ))}
        </Select>
    </FormControl>
    <FormControl fullWidth>
        <InputLabel>Select Service Type</InputLabel>
        <Select
            value={selectedService}
            label="Select Service Type"
            onChange={(event: SelectChangeEvent) => {
                setSelectedService(event?.target?.value)
            }}
        >
            {allServices?.map((eachService: {id: number; name: string}) => {
                return(
                    <MenuItem value={eachService?.id}>{eachService?.name}</MenuItem>
                )
            })}
        </Select>
    </FormControl>
    <Autocomplete
        multiple
        options={areaList?.map((each: { id: number; name: string }) => {
          return { label: each?.name, value: each?.id }
        })}
        sx={{ width: 300 }}
        renderInput={(params) => <TextField {...params} label="Area" />}
        value={selectedAreas}
        onChange={(event, newValue) => {
            setSelectedAreas(newValue);
        }}
    /> 
    </> 
    }
      </DialogContent>
      <DialogActions style={{ marginTop: "12px" }}>
        <Button
          variant="contained"
          onClick={() => {
            handleSubmit();
          }}
          size={"large"}
        >
          Submit
        </Button>
        <Button
          variant="contained"
          color={"error"}
          onClick={() => {
            props.callback(false);
          }}
          size={"large"}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AddMultipleSlcsDialog
